import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import SesHeader from "../header";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    SessionExpireCommonPopup,
    useScreenTransition,
    QuesLoader,
    useTimer,
    redirectToAssessmentSummary,
    useTimerValues,
} from "../../util/common";
import { BaseContext } from "../../App";

const LanguageTests = () => {
    const [test, setTest] = useState();
    const [selectedAns, setSelectedAns] = useState(-1);
    const [audioLoaded, setAudioLoaded] = useState(false);
    const [audioPlaying, setAudioPlaying] = useState(false);
    const [audioDisabled, setAudioDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const [sessionStatus, setSessionStatus] = useState(false);
    const { phase, loading, startTransition, done } = useScreenTransition();
    const { min, sec, totalSecLeft, setTimer, startTimer, stopTimer } =
        useTimer();
    const location = useLocation();
    const { timerPerQuestion } = useTimerValues();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const quesNo = useRef(-1);
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const audioRef = useRef();
    const timesPlayed = useRef(0);
    const wrong35ExitRef = useRef(false);
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });

    const changeSelectedAns = (e) => {
        setSelectedAns(e.target.value);
    };

    const detectKeyDown = (e) => {
        e.preventDefault();
        if (!loading) {
            if (e.code in keyMappings.current) {
                setSelectedAns(keyMappings.current[e.code]);
            }
            if (selectedAns !== -1 && e.code === "Space") {
                nextNavigate();
            }
        }
    };

    const nextNavigate = async (expire) => {
        startTransition(async () => {
            const elapsedTime = stopTimer();
            const ansObj = { answers: [], structure: null, value: selectedAns };
            let quesObj = test.questions;
            quesObj[0].userAnswer = ansObj;
            quesObj[0].duration = elapsedTime;
            const otherData = {
                playTimes: timesPlayed.current,
                duration: elapsedTime,
                instrumentType: location.state.test.instrumentType,
                fwdtimes: 0,
                pause: false,
                rwdTimes: 0,
            };
            try {
                let response;
                if (test.lastPage || expire === "sessionEnded") {
                    response = await postCall(
                        TEST_COMPLETE + location.state.test.id,
                        { ...otherData, questions: quesObj },
                        header.current
                    );
                } else {
                    response = await postCall(
                        TEST_QUESTIONS + location.state.test.id,
                        { ...otherData, questions: quesObj },
                        header.current
                    );
                }
                if (response.data.status === true) {
                    if (
                        response.data.action &&
                        response.data.action.toUpperCase() === "FINISH"
                    ) {
                        wrong35ExitRef.current = true;
                        exitTest(response.data);
                    } else if (test.lastPage || expire === "sessionEnded") {
                        navigate("/");
                    } else {
                        setSelectedAns(-1);
                        formRef.current.reset();
                        quesNo.current += 1;
                        await getQuestion();
                    }
                }
            } catch (error) {
                console.log(error);
            }
            done();
        }, true);
    };
    const buildMediaUrl = (file) => {
        file = file.replace(
            /(.*)\.[^.]+$/,
            function (match, string, position, template) {
                return string;
            }
        );
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static/multimedia";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };

    const buildImageUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };

    const getQuestion = async () => {
        setAudioLoaded(false);
        setAudioDisabled(false);
        setAudioPlaying((prev) => {
            if (prev) {
                audioRef.current.pause();
            }
            return false;
        });
        try {
            const response = await getNoCacheCall(
                TEST_QUESTIONS + location.state.test.id + "/" + quesNo.current,
                header.current
            );
            setTest(response.data[0]);
            quesNo.current = response.data[0].startNumber;
            let key;
            keyMappings.current = {};
            response.data[0].questions[0].answers.map((val) => {
                key = `Digit${val.position + 1}`;
                keyMappings.current = {
                    ...keyMappings.current,
                    [key]: val.position,
                };
            });
            const timeLimit = atob(
                response.data[0].questions[0].encTmLmt
            ).split(":")[1];
            if (response.data[0].questions[0].media !== null) {
                timesPlayed.current = 0;
                setTimer(timeLimit);
            } else startTimer(timeLimit, "timeByQuestion");
        } catch (error) {
            console.log();
        }
    };

    const exitTest = (wrong35Exit) => {
        if (wrong35Exit) {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.[wrong35Exit.outPutMsg],
                    popupFooter: phrases?.["10928"],
                };
                return prev;
            });
        } else {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        if (wrong35ExitRef.current) {
            approveAction();
        } else navigate("/");
    };

    const approveAction = async () => {
        const elapsedTime = stopTimer();
        const ansObj = { answers: [], structure: null, value: selectedAns };
        let quesObj = test.questions;
        quesObj[0].userAnswer = ansObj;
        quesObj[0].duration = elapsedTime;
        const otherData = {
            playTimes: timesPlayed.current,
            duration: elapsedTime,
        };
        const response = await postCall(
            TEST_COMPLETE + location.state.test.id,
            { ...otherData, questions: quesObj },
            header.current
        );
        redirectToAssessmentSummary(location, navigate);
    };

    const handleAudioPlay = (stopped = false) => {
        if (timesPlayed.current === 0) {
            startTimer(undefined, "timeByQuestion");
        }
        if (stopped) {
            setAudioPlaying(false);
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        } else {
            if (timesPlayed.current === 1) {
                setAudioDisabled(true);
            }
            setIsLoading(false);
            setAudioLoaded(true);
            setAudioPlaying(true);
            audioRef.current.play();
            timesPlayed.current += 1;
        }
    };

    const handlePlayButtonClick = (e) => {
        e.preventDefault();
        if (audioRef.current) {
            if (audioLoaded) {
                if (audioPlaying) {
                    handleAudioPlay(true);
                } else {
                    handleAudioPlay();
                }
            } else {
                setIsLoading(true);
                //setAudioLoaded(true);
                audioRef.current.load();
                handleAudioPlay();
            }
        }
    };

    useEffect(() => {
        attachKeyListenRef.current?.focus({
            preventScroll: true,
        });
    }, [test]);

    useEffect(() => {
        if (totalSecLeft === 0) {
            if (test.lastPage) {
                setSessionStatus(true);
            } else {
                nextNavigate();
            }
        }
    }, [totalSecLeft]);

    useEffect(() => {
        getQuestion();
    }, []);

    const sessionApproveAction = async () => {
        setSessionStatus(false);
        nextNavigate("sessionEnded");
    };

    if (!test) {
        return <CommonLoader />;
    }

    return (
        <>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) =>
                    e.target.focus({
                        preventScroll: true,
                    })
                }
                style={{ outline: "none" }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <SessionExpireCommonPopup
                    sessionStatus={sessionStatus}
                    sessionApproveAction={sessionApproveAction}
                />
                <CommonQuesProgress test={test} />
                <div className="flex_col g2">
                    <h3>{location.state.test.name}</h3>
                    <div
                        className="base"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <form
                    ref={formRef}
                    className="flex_row flex_col_mobile position_relative g2"
                >
                    <QuesLoader show={phase === "showing-loader"} />
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="small-title">
                            {phrases?.["13106"]} {test.startNumber}
                        </div>
                        <div className="base p4 roundness_1 border_tt82 full-height">
                            <div
                                className="questionText"
                                dangerouslySetInnerHTML={{
                                    __html: test.questions[0].questionText,
                                }}
                            />
                            {test.questions[0]?.media &&
                                test.questions[0]?.media.map((val, ind) => (
                                    <div
                                        key={test.startNumber + ind}
                                        className="p2 roundness_1 border_tt82"
                                        style={{ width: "fit-content" }}
                                    >
                                        <audio
                                            ref={audioRef}
                                            preload="auto"
                                            onEnded={() =>
                                                handleAudioPlay(true)
                                            }
                                        >
                                            <source
                                                src={`${buildMediaUrl(
                                                    val.url
                                                )}.ogg`}
                                                type="audio/ogg"
                                            />
                                            <source
                                                src={`${buildMediaUrl(
                                                    val.url
                                                )}.mp3`}
                                                type="audio/mpeg"
                                            />
                                            Your browser does not support the
                                            audio element.
                                        </audio>
                                        <button
                                            disabled={audioDisabled}
                                            className="button-icon_large"
                                            iconPosition="left"
                                            onClick={(e) =>
                                                handlePlayButtonClick(e)
                                            }
                                        >
                                            {isLoading ? (
                                                "Loading..."
                                            ) : (
                                                <span className="material-icons">
                                                    {audioPlaying
                                                        ? "stop_circle"
                                                        : "play_arrow"}
                                                </span>
                                            )}
                                        </button>
                                    </div>
                                ))}
                        </div>
                        {test.questions[0]?.questionImage && (
                            <div className="base p4 roundness_1 border_tt82 full-height">
                                <img
                                    src={buildImageUrl(
                                        test.questions[0]?.questionImage
                                    )}
                                    alt="question-image"
                                    className="ques-img mt1"
                                />
                            </div>
                        )}
                    </div>

                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="flex_row justify-content_between">
                            <div className="small-title">
                                {phrases?.["15138"]}
                            </div>
                            <div
                                className={`tag-ds ${timerPerQuestion > 0 &&
                                        timerPerQuestion < totalSecLeft
                                        ? "status-tag_info"
                                        : "status-tag_error"
                                    }`}
                            >
                                <span className="material-icons-outlined icon-order">
                                    timer
                                </span>
                                {min}:{sec}
                            </div>
                        </div>

                        <fieldset
                            aria-label="group-container"
                            className="radio-group-container"
                        >
                            <div className="radio-group base p4 roundness_1 border_tt82 full-height">
                                {test.questions[0].answers.map((val, ind) => (
                                    <div
                                        key={test.startNumber + ind}
                                        className="radio-container"
                                    >
                                        <input
                                            id={`option-${ind}`}
                                            type="radio"
                                            name="llt_options"
                                            value={val.position}
                                            onChange={changeSelectedAns}
                                            checked={
                                                selectedAns == val.position
                                            }
                                        />
                                        <label
                                            dangerouslySetInnerHTML={{
                                                __html: val.content,
                                            }}
                                            htmlFor={`option-${ind}`}
                                        />
                                    </div>
                                ))}
                            </div>
                        </fieldset>
                    </div>
                </form>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage ? (
                        <div />
                    ) : (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={() => exitTest(false)}
                            disabled={loading}
                        >
                            {phrases?.["1002190"]}
                        </button>
                    )}
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        disabled={selectedAns === -1 || loading}
                        onClick={nextNavigate}
                    >
                        {test.lastPage
                            ? phrases?.["15140"]
                            : phrases?.["10976"]}
                        <span className="material-icons right">
                            arrow_forward
                        </span>
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
        </>
    );
};

export default LanguageTests;
